/* eslint-disable react/no-danger */
import React from 'react';
import { get } from 'lodash-es';
import shortid from 'shortid';
import Img from 'gatsby-image';
import { FaQuoteLeft } from 'react-icons/fa';
import OptimizedImage from '../OptimizedImage';
// import useAuthorPlaceholderImage from '../../graphql/staticQueries/useAuthorPlaceholderImage';

const HomeTestimonialsCard = ({ testimonial, logo, careers }) => {
  // const defaultUserImg = useAuthorPlaceholderImage();
  const authorPhoto = get(testimonial, 'author.photo.childImageSharp.fixed');

  const opinionDetails = testimonial.content.replace(/<[^>]*>?/gm, '');

  function createMarkup() {
    return { __html: opinionDetails };
  }

  return (
    <>
      <div className="left-pistil">
        <div className="author">
          {careers ? (
            <OptimizedImage
              className="img-fluid largeImg"
              src={testimonial.image}
            />
          ) : (
            <Img
              fixed={authorPhoto}
              alt={testimonial.author.title}
              title={testimonial.author.title}
            />
          )}
          <div className="neck">
            <div className={`name ${careers && 'lgImg '}`}>
              {testimonial.author.title}
            </div>
            {!careers && (
              <div className="description">{testimonial.author.subtitle}</div>
            )}
          </div>
        </div>
        {!careers && (
          <div className="company">
            <Img
              fixed={logo}
              className="logo"
              alt="company logo"
              title="company logo"
            />
          </div>
        )}
      </div>
      <div className="right-pistil">
        <div className="opinion">
          <FaQuoteLeft className="quote-top" />
          <div
            className="opinion-details"
            dangerouslySetInnerHTML={createMarkup()}
            key={shortid.generate()}
          />
          <FaQuoteLeft className="quote-bottom" />
        </div>
      </div>
    </>
  );
};

export default HomeTestimonialsCard;
